import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Breadcrumb, Message, Spin, Card, Row, Col, Modal } from 'antd';
import { Product } from "../../../models";
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import { Form } from '../../../components';
import styles from './index.less';

const { confirm } = Modal;

const mapStateToProps = state => ({
  currentProduct: state.product.current,
  categories: state.category.all.data,
  categoriesLoading: state.category.all.isLoading,
});

class ProductForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {
        schema: {
          definitions: {
            Option: {
              title: 'Option!',
              type: 'object',
              required: ['name', 'images'],
              column: 12,
              properties: {
                name: {
                  type: 'string',
                  label: 'Нэр',
                },
                images: {
                  type: 'array',
                  label: 'Зураг',
                  items: {
                    type: 'object',
                  },
                },
              },
            },
          },
          root: true,
          title: 'Form',
          type: 'object',
          required: ['relation_id', 'description', 'price', 'title', 'barcode', 'quantity'],
          column: 12,
          properties: {
            relation_id: {
              type: 'string',
              label: 'Категори',
              options: this.props.categories || [],
            },
            title: {
              type: 'string',
              label: 'Гарчиг',
            },
            productImages: {
              type: 'array',
              label: 'Зураг',
              items: {
                type: 'object',
              },
            },
            options: {
              type: "array",
              title: 'Өнгө',
              items: {
                $ref: "#/definitions/Option",
              },
            },
            description: {
              type: 'string',
              placeholder: 'Барааны нарийвчилсан мэдээлэл оруулна уу',
              label: 'Дэлгэрэнгүй мэдээлэл',
            },
            barcode: {
              type: 'string',
              label: 'Бар код',
            },
            price: {
              type: 'number',
              placeholder: 'Барааны үнэ оруулна уу',
              label: 'Үнэ',
            },
            discount_price: {
              type: 'number',
              label: 'Хямдарсан үнэ',
            },
            quantity: {
              type: 'number',
              placeholder: 'Нийт үлдсэн тоо хэмжээ',
              label: 'Үлдэгдэл',
            },
            position: {
              type: 'number',
              placeholder: 'Эрэмбэ оруулна уу',
              label: 'Эрэмбэ',
            },
            inactive: {
              type: 'boolean',
              name: 'asdaasd',
              label: 'Идэвхтэй эсэх',
              placeholder: 'Тийм',
            },
          },
        },
        uiSchema: {
          'ui:order': ['relation_id', 'title', '*', 'options', 'description', 'barcode', 'price', 'discount_price', 'quantity', 'position', 'inactive'],
          relation_id: {
            "ui:widget": "cascader",
          },
          title: {
            "ui:widget": "input",
            "ui:placeholder": "Гарчиг оруулна уу",
          },
          productImages: {
            // "ui:widget": "image",
            "ui:field": "images",
          },
          options: {
            items: {
              name: {
                "ui:widget": "input",
                "ui:placeholder": "Цагаан",
              },
              images: {
                "ui:field": "images",
              },
            },
          },
          description: {
            "ui:widget": 'textarea',
            "ui:placeholder": "Дэлгэрэнгүй мэдээлэл оруулна уу",
          },
          barcode: {
            "ui:widget": 'input',
            "ui:placeholder": "Бар код оруулна уу",
          },
          price: {
            "ui:widget": 'number',
            "ui:placeholder": "Барааны үнэ оруулна уу",
          },
          discount_price: {
            "ui:widget": 'input-number',
            "ui:placeholder": "Хямдарсан үнэ",
          },
          quantity: {
            "ui:widget": "number",
            "ui:placeholder": "Үлдэгдэл",
          },
          position: {
            "ui:widget": "number",
            "ui:placeholder": "Эрэмбэ",
          },
          inactive: {
            "ui:widget": "switch",
            "ui:placeholder": "Идэвхгүй",
          },
        },
      },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (!this.props.match.params.id) {
      this.props.formReset();
    }
    this.setLoadingFalse();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id && !nextProps.match.params.id) {
      this.props.formReset();
      this.setState({ loading: true }, () => this.setLoadingFalse());
    }
    if (this.props.categoriesLoading === true && nextProps.categoriesLoading === false) {
      this.setState({
        form: {
          ...this.state.form,
          schema: {
            ...this.state.form.schema,
            properties: {
              ...this.state.form.schema.properties,
              relation_id: {
                ...this.state.form.schema.properties.relation_id,
                options: nextProps.categories,
              },
            },
          },
        },
      });
    }
  }

  setLoadingFalse = () => {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 300);
  }

  handleDelete = async ({ body }) => {
    confirm({
      title: 'Та уг барааг устгахдаа итгэлтэй байна уу?',
      // content: 'Some descriptions',
      okText: 'Тийм',
      okType: 'danger',
      cancelText: 'Үгүй',
      onOk: async () => {
        await this.props.productDelete({ body });
        Message.success('Барааг амжилттай устгалаа');
        if (!this.props.currentProduct.error) this.props.history.push({ pathname: '/products' });
        // console.log('OK', body, this.props.productDelete);
      },
      onCancel: () => {
        console.log('Cancel');
      },
    });


    // this.props.productDelete({ body });
  }

  handleSubmit = async (data) => {
    if (data.formData.relation_id) {
      const array = data.formData.relation_id.split(' / ');
      data.formData.relation_id = array[array.length - 1];
    }
    // console.log('checked', data.formData.productImages.checked);
    if (data.formData.productImages) {
      let tempImages = data.formData.productImages;
      if (tempImages.length) {
        data.formData.productImages = tempImages.map((image) => {
          if (image.response) {
            return {
              ...image.response.data,
              is_main: image.is_main || false,
            };
          }

          return image;
          // ({
          //   dump_link: image.response && image.response.data.dump_link,
          //   link: image.thumbUrl,
          //   is_main: image.is_main || false,
          // })
        });
      }
    }

    if (this.props.match.params.id) {
      await this.props.productUpdate({ body: data.formData });
      // console.log('productUpdate works: ', this.props);
      if (this.props.currentProduct.error) {
        Message.error('Барааг засах амжилтгүй');
      } else {
        Message.success('Барааг амжилттай заслаа');
        this.props.history.push({ pathname: '/products' });
      }
    } else {
      await this.props.productCreate({ body: data.formData });
      // console.log('productCreate works: ', this.props);
      if (this.props.currentProduct.error) {
        Message.error('Барааг нэмэх амжилтгүй');
      } else {
        Message.success('Барааг амжилттай нэмлээ');
        this.props.history.push({ pathname: '/products' });
      }
    }
  }

  validate = (formData, errors) => {
    if (formData.productImages && formData.productImages.length) {
      if (formData.productImages.reduce((accumilator, current) => {
        if (accumilator || current.status === 'uploading') {
          return true;
        }
        return accumilator;
      }, false)) {
        errors.productImages.addError('Зураг хуулж дуусаагүй байна');
      }
    }
    return errors;
  }

  loading = () => (
    <div className={styles.loading}>
      <Spin />
    </div>
  )

  breadcrumb = (
    <div className={styles.pageTop}>
      <Breadcrumb className={styles.Topbread}>
        <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
        <Breadcrumb.Item><Link to="/products">Бараа</Link></Breadcrumb.Item>
        {
          this.props.match.params.id ? <Breadcrumb.Item>Бараа засварлах</Breadcrumb.Item> : <Breadcrumb.Item>Бараа нэмэх</Breadcrumb.Item>
        }
      </Breadcrumb>
    </div>
  );

  processForm = (formData, callback) => {
    if (formData.options && formData.options.length) {
      let newSchema = { ...this.state.form.schema };

      delete newSchema.properties.productImages;

      let newState = {
        form: {
          ...this.state.form,
          schema: newSchema,
        },
      };

      this.setState(newState, () => {
        callback(data => data);
      });
    } else {
      const productImages = {
        type: 'array',
        label: 'Зураг',
        items: {
          type: 'object',
        },
      };

      this.setState({
        form: {
          ...this.state.form,
          schema: {
            ...this.state.form.schema,
            properties: {
              ...this.state.form.schema.properties,
              productImages,
            },
          },
        },
      }, () => {
        callback(data => data);
      });
    }
  }

  render() {
    return (
      <PageHeaderLayout
        content={this.breadcrumb}
      >
        {
          this.state.loading ?
          this.loading() :
          <Card bordered={false} >
            <Row>
              <Col span={24} className={styles.formCol}>
                <Form
                  form={this.state.form}
                  data={this.props.currentProduct.data}
                  fetchData={this.props.match.params.id ? this.props.productDetail : undefined}
                  dataParams={{ body: { id: this.props.match.params.id } }}
                  processForm={this.processForm}
                  validate={this.validate}
                  delete={this.handleDelete}
                  onSubmit={this.handleSubmit}
                  submitButtonName={this.props.match.params.id ? 'Засах' : 'Нэмэх'}
                />
              </Col>
            </Row>
          </Card>
        }
      </PageHeaderLayout>
    );
  }
}

ProductForm.propTypes = {
  categories: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object,
  productDetail: PropTypes.func.isRequired,
  productDelete: PropTypes.func,
  productCreate: PropTypes.func.isRequired,
  productUpdate: PropTypes.func.isRequired,
  formReset: PropTypes.func.isRequired,
  categoriesLoading: PropTypes.bool.isRequired,
  currentProduct: PropTypes.object,
};

ProductForm.defaultProps = {
  currentProduct: undefined,
  productDelete: undefined,
  history: undefined,
};


export default connect(mapStateToProps, {
  formReset: Product.reset,
  productDetail: Product.get,
  productCreate: Product.create,
  productDelete: Product.delete,
  productUpdate: Product.update,
})(ProductForm);



// WEBPACK FOOTER //
// ./src/containers/Products/Form/index.js